import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { PostingAccountAction, usePostingAccountProvider } from '../Finance.PostingAccount.Hooks';

export default function FinancePostingAccountList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = usePostingAccountProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.postingAccounts}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.postingAccountName}</th>
          <th>{lang.currency}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: postingAccount }) => (
            <tr key={postingAccount.id}>
              <td>
                <b>{postingAccount.ledgerAccountName}</b>
              </td>
              <td>{postingAccount.currency}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: postingAccount.id.toString(),
                      action: PostingAccountAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_LEDGERACCOUNT}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.edit,
                    }}
                    media={<Icon class="fas-edit" />}
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: postingAccount.id.toString(),
                      action: PostingAccountAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_LEDGERACCOUNT}
                    active
                    class={ThemeButtonCircle}
                    htmlElementProps={{
                      title: lang.delete,
                    }}
                    media={<Icon class="fas-trash" />}
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
